import type { SVGProps } from "react";
// generated from First.svg — do not edit manually
// prettier-ignore
export default function First(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 11 12 L 10.47 11.4697 L 9.939 12 L 10.47 12.5303 L 11 12 Z M 7 6 H 6.25 V 18 H 7 H 7.75 V 6 H 7 Z M 17 6 L 16.47 5.46967 L 10.47 11.4697 L 11 12 L 11.53 12.5303 L 17.53 6.53033 L 17 6 Z M 11 12 L 10.47 12.5303 L 16.47 18.5303 L 17 18 L 17.53 17.4697 L 11.53 11.4697 L 11 12 Z" fill="currentColor"/></svg>);
}
